<button
  matRipple
  class="trigger"
  type="button"
  #triggerElement
  #origin="cdkOverlayOrigin"
  cdkOverlayOrigin
  aria-haspopup="dialog"
  [attr.aria-expanded]="opened()"
  [attr.aria-label]="
    'Benachrichtigungen' + (unreadCount() > 0 ? ', ' + unreadCount() + ' ungelesen' : '')
  "
  (click)="toggle()"
>
  <mat-icon aria-hidden="true">notifications</mat-icon>

  @if (unreadCount() > 0) {
    <span class="badge" aria-hidden="true">{{ unreadCount() }}</span>
  }
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="opened()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayPositions]="[
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 },
  ]"
  (backdropClick)="close()"
  (overlayKeydown)="onOverlayKeydown($event)"
>
  <div
    class="panel"
    role="dialog"
    aria-label="Benachrichtigungen"
    cdkTrapFocus
    cdkTrapFocusAutoCapture
  >
    <div class="panel-header">
      <span class="panel-heading">Benachrichtigungen</span>

      <button immoButton theme="primary-container" size="xs" (click)="onMarkAllRead()">
        Alle als gelesen
      </button>
    </div>

    <ul class="list">
      @for (notification of notifications(); track notification.id) {
        <li class="list-entry">
          <button class="item" type="button" (click)="onNotificationSelected(notification)">
            <span class="dot" [class.dot-read]="notification.read" aria-hidden="true"></span>

            <span class="item-body">
              <span class="item-title">{{ notification.title }}</span>
              <span class="item-meta">
                {{ notification.address }} · # {{ notification.channel }} ·
                {{ notification.author }}
              </span>
            </span>
          </button>
        </li>
      } @empty {
        <li class="empty">Keine neuen Benachrichtigungen</li>
      }
    </ul>

    <div class="panel-footer">
      <button
        immoButton
        icon="arrow-right"
        theme="primary-inverse"
        iconPosition="end"
        size="sm"
        (click)="onViewAll()"
      >
        Alle Benachrichtigungen ansehen
      </button>
    </div>
  </div>
</ng-template>
